export default "__VITE_ASSET__DV16aGx7__"